import { jsx as o, jsxs as b, Fragment as s } from "react/jsx-runtime";
import { ChevronUpIcon as v, ChevronDownIcon as x } from "../../icons/index.es.js";
import { useMemo as S, useState as C, useEffect as M } from "react";
import { Button as w } from "../Button/Button.es.js";
import { Menu as y, MenuButton as I, MenuList as k } from "../Menu/index.es.js";
import { SelectDropdownMenuItem as D } from "./SelectDropdownMenuItem.es.js";
const E = ({
  defaultValue: c,
  listProps: u,
  options: e,
  size: t = "md",
  trackId: f,
  variant: d = "ghost",
  iconStyles: l = {},
  menuButtonProps: p = {},
  ...h
}) => {
  const n = S(
    () => e.find((m) => m.value === c),
    [c, e]
  ), [r, i] = C(
    n
  );
  return M(() => {
    n || i(e[0]), n !== r && i(n);
  }, [n, e]), /* @__PURE__ */ o(y, { size: t, variant: d, ...h, gutter: 0, children: ({ isOpen: m }) => /* @__PURE__ */ b(s, { children: [
    /* @__PURE__ */ o(
      I,
      {
        size: t,
        _active: {
          borderColor: "none",
          backgroundColor: "primary.200"
        },
        _focusWithin: {
          borderColor: "none"
        },
        _hover: {
          backgroundColor: "primary.100"
        },
        as: w,
        border: "none",
        borderRadius: "100px",
        color: "primary.500",
        fontSize: "lg",
        fontWeight: "medium",
        lineHeight: "14px",
        paddingX: 4,
        paddingY: 2,
        rightIcon: m ? /* @__PURE__ */ o(v, { color: "primary.700", boxSize: 6, ...l }) : /* @__PURE__ */ o(x, { color: "primary.700", boxSize: 6, ...l }),
        textAlign: "left",
        "track-id": f,
        variant: "transparent",
        width: "auto",
        ...p,
        children: r == null ? void 0 : r.label
      }
    ),
    /* @__PURE__ */ o(k, { ...u, children: e.map((a) => {
      const g = a.value === (r == null ? void 0 : r.value);
      return /* @__PURE__ */ o(
        D,
        {
          option: a,
          variant: d,
          size: t,
          onSelectOption: i,
          isSelected: g
        },
        a.value
      );
    }) })
  ] }) });
};
export {
  E as SelectDropdown
};
//# sourceMappingURL=SelectDropdown.es.js.map
